import {UserProfile} from '~/redux/questionnaires/types';
import {UiFormControl, UiFormErrorMessage, UiFormLabel, UiInput} from '~/components/elements';
import {spacing} from '~/utils/theme/spacing';
import React, {memo} from 'react';
import BooleanDropdown from '~/components/dropdowns/BooleanDropdown';
import {useDisclosure} from '@chakra-ui/react';
import {NO_DRUG_ALLERGIES} from '~/constants/medical-questionnaires';

export const DrugAllergies = memo(
  ({
    inputs: {drugAllergies, hasDrugAllergies},
    onChange,
    errorMsg,
  }: {
    inputs: UserProfile & {isPickingDate: boolean; hasDrugAllergies?: boolean};
    onChange: (value: any) => void;
    errorMsg?: string;
  }) => {
    const noDrugAllergies = drugAllergies?.toUpperCase() === NO_DRUG_ALLERGIES;

    const {isOpen, onClose, onOpen} = useDisclosure({
      defaultIsOpen: !!drugAllergies && !noDrugAllergies,
    });
    const onChangeAllergicOption = (option: any) => {
      if (!option?.value) {
        onChange({drugAllergies: '', hasDrugAllergies: false});
        onClose();
      }
      if (option?.value) {
        onChange({drugAllergies: '', hasDrugAllergies: true});
        onOpen();
      }
    };

    return (
      <UiFormControl id="drugAllergies" mt={spacing.tiny} isRequired isInvalid={!!errorMsg}>
        <UiFormLabel fontWeight="400" fontSize="xs">
          Drug Allergies
        </UiFormLabel>
        <BooleanDropdown
          includeAll={false}
          defaultValue={hasDrugAllergies && !noDrugAllergies ? drugAllergies : noDrugAllergies ? false : undefined}
          selectedFontWeight="600"
          onChange={onChangeAllergicOption}
        />
        {isOpen && (
          <UiInput
            mt={3}
            variant="flushed"
            defaultValue={drugAllergies}
            onChange={({target}) => onChange({drugAllergies: target.value})}
            fontWeight="600"
            placeholder="Drug Allergies..."
          />
        )}
        {errorMsg && <UiFormErrorMessage>{errorMsg}</UiFormErrorMessage>}
      </UiFormControl>
    );
  },
);
